const isDev = window &&
    window.location && (
        window.location.hostname === "localhost" ||
        window.location.port === "5001"
    );

export default isDev;